var numberUtils = require('./utils/numberUtils');
var setupHandlebarsHelpers = require('./../target/node_modules/vecna-javascript/handlebars-helpers.js');
var setupTorsoHandlebarsHelpers = require('backbone-torso/modules/handlebarsUtils');
var staticImageUrl = require('./urls').staticImageService;

/**
 * All helper functions for the Handlebars.js templating engine
 * @class frontendHandlebarsHelpers
 * @param Handlebars {Handlebars} the handlebars instance to attach the helpers to.
 */
module.exports = function(Handlebars) {
  setupHandlebarsHelpers(Handlebars, staticImageUrl);
  setupTorsoHandlebarsHelpers(Handlebars);

  /**
   * Example:
   {{isFalse view.yesEnabled}}

   * Helper that checks for false, not falsey.
   * @param conditional {boolean} the conditional to check if false.
   */
  Handlebars.registerHelper('isFalse', function(conditional) {
    return conditional === false;
  });

  /**
   * Example:
   {{formatCardNumber fullCardNumber}}

   * Helper that formats the credit card to have spaces every 4 digits.
   * @param fullCardNumber {String} the full card number to format.
   */
  Handlebars.registerHelper('formatCardNumber', function(fullCardNumber) {
    var cardNumberParts = fullCardNumber.match(/.{1,4}/g); // splits into segments 4 characters long (or less if not divisible by 4).
    return cardNumberParts.join(' ');
  });

  /**
   * Helper for concatenpating a list of values. All arguments will be joined and returned.
   */
  Handlebars.registerHelper('concat', function() {
    return Array.prototype.slice.call(arguments, 0, arguments.length -1).join('');
  });

  /**
   * Helper for converting from zero-based to one-based indexing
   * @param zeroBasedIndex {Number} the zero-based index number
   */
  Handlebars.registerHelper('convertZeroToOneBased', function(zeroBasedIndex) {
    return numberUtils.convertZeroToOneBased(zeroBasedIndex);
  });

  /**
   * Helper for encoding user input into a url
   * @param component {String} the component
   */
  Handlebars.registerHelper('encodeURIComponent', function(component) {
    return encodeURIComponent(component);
  });
};
